/* eslint-disable */

/** unique or primary key constraints on table "argo.material" */
export enum ArgoMaterialConstraint {
  /** unique or primary key constraint on columns "material_id" */
  MaterialPkey = 'material_pkey',
  /** unique or primary key constraint on columns "context_id", "serial_number", "material_model_id" */
  MaterialSerialNumberInactiveModelUnique = 'material_serial_number_inactive_model_unique'
}

/** select columns of table "argo.material" */
export enum ArgoMaterialSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material" */
export enum ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** select "argo_material_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material" */
export enum ArgoMaterialSelectColumnArgoMaterialAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  SerialNumberActive = 'serial_number_active'
}

/** update columns of table "argo.material" */
export enum ArgoMaterialUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SerialNumberActive = 'serial_number_active',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

